import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine, Tooltip } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { TooltipPosition } from 'theme/enums';

export const TradeAgreementOwnerCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'tradeAgreementOwnerName');
  if (!data) {
    return props?.value;
  }

  const { tradeAgreementOwnerName, tradeAgreementOwnerEmail } = data;
  // The BE nulls both fields together when the quote has no owner or the saved one is no longer
  // eligible, so a missing name means there is nothing to anchor the email tooltip on.
  if (!tradeAgreementOwnerName) {
    return <TextLine text={DEFAULT_PLACEHOLDER} />;
  }

  const ownerLine = <TextLine text={tradeAgreementOwnerName} />;

  if (!tradeAgreementOwnerEmail) {
    return ownerLine;
  }

  return (
    <Tooltip title={tradeAgreementOwnerEmail} placement={TooltipPosition.TOP}>
      {ownerLine}
    </Tooltip>
  );
};
